/* eslint-disable no-undef */
import { Map, Marker } from '@vis.gl/react-google-maps';
import React, { useEffect, useMemo, useState } from 'react';
import { createUseStyles } from 'react-jss';
// import tinycolor from 'tinycolor2';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AddressCard } from './address-card';
import { layoutDefaults } from '../../utils/layout-defaults';
import { useGoogleMapsGeometry } from '../../hooks/use-google-maps-geometry';
import { maxToleranceBeetwenMapPoints } from '../../utils/manager/map-manager';

// const backgroundColor = tinycolor(layoutDefaults.cardColor)
//   .darken(5)
//   .toHex8String();
const defaultZoom = 18;

function AddressMapModalBody({
  config,
  placeDetails,
  baseLocation,
  noStreetNumber,
  complement,
  center: pCenter,
  onCenterChanged,
  onDistanceChanged,
}) {
  const [center, setCenter] = useState(
    pCenter ?? placeDetails.geometry.location
  );
  const [distance, setDistance] = useState(0);
  const { isGeometryLoaded, geometry } = useGoogleMapsGeometry();
  const { t } = useTranslation();
  const classes = useStyles();

  const mapId = useMemo(() => placeDetails.place_id, [placeDetails]);

  // const defaultCenter = useMemo(
  //   () => placeDetails.geometry.location,
  //   [placeDetails]
  // );

  useEffect(() => {
    onDistanceChanged?.call(this, distance);
  }, [distance]);

  useEffect(() => {
    onCenterChanged?.call(this, center);

    if (isGeometryLoaded) {
      const value = geometry.spherical.computeDistanceBetween(
        placeDetails.geometry.location,
        center
      );

      setDistance(value);
    }
  }, [center, isGeometryLoaded, geometry, placeDetails]);

  const handleOnCenterChanged = (event) => {
    setCenter(event.detail.center);
  };

  const handleOnCenterReset = () => {
    setCenter(placeDetails.geometry.location);
  };

  return (
    <div className={classes.container}>
      {center != null && (
        <Map
          mapId={mapId}
          reuseMaps
          // style={{ width: '100%', height: '40vh' }}
          className={classes.map}
          defaultCenter={placeDetails.geometry.location}
          center={center}
          defaultZoom={defaultZoom}
          clickableIcons={false}
          fullscreenControl={false}
          gestureHandling="greedy"
          disableDefaultUI
          defaultTilt={0}
          tiltInteractionEnabled={false}
          mapTypeId="hybrid"
          scrollwheel={false}
          disableDoubleClickZoom
          keyboardShortcuts={false}
          onCenterChanged={handleOnCenterChanged}
        >
          <Marker
            position={center}
            animation={google.maps.Animation.DROP}
            clickable={false}
            draggable={false}
          />
        </Map>
      )}

      <AddressCard
        showMap={false}
        config={config}
        className={classes.addressCard}
        placeDetails={placeDetails}
        baseLocation={baseLocation}
        noStreetNumber={noStreetNumber}
        complement={complement}
        showMarker={false}
      />

      <div className={classes.markerInfoContainer}>
        {distance <= maxToleranceBeetwenMapPoints && (
          <FadeIn className={classes.markerInfo}>
            <span>*{t('address-map-modal.info')}</span>
          </FadeIn>
        )}

        {distance > maxToleranceBeetwenMapPoints && (
          <FadeIn>
            <Button
              variant="link"
              className={classes.link}
              onClick={handleOnCenterReset}
            >
              {t('address-map-modal.center.button')}
            </Button>
          </FadeIn>
        )}
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginTop: -layoutDefaults.verticalMargin,
  },
  addressCard: {
    // backgroundColor,

    paddingTop: layoutDefaults.bigVerticalMargin,
    marginTop: -layoutDefaults.smallVerticalMargin - 2,
    // zIndex: -100,
    //   layoutDefaults.smallestVerticalMargin,
    // marginBottom: layoutDefaults.smallVerticalMargin,
  },
  map: {
    width: '100%',
    height: '40vh',

    borderRadius: layoutDefaults.radius,
    overflow: 'hidden',
  },
  markerInfoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontSize: layoutDefaults.fontSize,

    marginTop: layoutDefaults.bigVerticalMargin,
    // paddingTop: layoutDefaults.smallVerticalMargin,
    // paddingBottom: layoutDefaults.smallVerticalMargin,
    borderRadius: layoutDefaults.radius,

    minHeight: layoutDefaults.fontSize * 3,

    // backgroundColor,
    // border: '1px solid red',
  },
  markerInfo: {
    opacity: layoutDefaults.opacity,
    // fontSize: layoutDefaults.fontSize,
  },
  link: {
    cursor: 'pointer',
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.linkColor,
    marginLeft: layoutDefaults.smallestHorizontalMargin,
    padding: 0,
    margin: 0,
  },
});

export { AddressMapModalBody };
